import React, { useEffect, useState, createRef } from "react";
import { Alert, Button, Form, Input, Select, notification } from "antd";
import { FormInstance } from "antd/es/form/Form";
import { Forms } from "models/form";
import { UserModel } from "models/userCollectionModel";
import { useUpdateAdmin } from "lib/core-react/hooks/private/useAdminUser";
import { IUserStatus } from "types/userCollection";
import { useAtom } from "jotai";
import { roleAtom } from "lib/core-react/store/store";
import { RoleCollectionModel } from "models/roleCollectionModel";
import { useGetRole } from "lib/core-react/hooks/private";
import { renderOptionsFromEnum } from "components/Form/forms";

interface IProps {
  setIsModalVisible: React.Dispatch<React.SetStateAction<boolean>>;
  selectedRoles: UserModel;
}

const UpdateAdminUserRoleOnly = ({
  setIsModalVisible,
  selectedRoles,
}: IProps) => {
  console.log(selectedRoles, "seletedRoles");
  const { updateAdmin, isLoading, isError } = useUpdateAdmin();
  const { getRole } = useGetRole();
  const [isErrorVisible, setIsErrorVisible] = useState(false);
  const [{ data: roleData, refetch }] = useAtom(roleAtom);

  const RoleData = roleData && new RoleCollectionModel(roleData);

  // Api Call
  useEffect(() => {
    getRole();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refetch]);

  const formRef: React.Ref<FormInstance<any>> = createRef();
  const [form] = Form.useForm();

  useEffect(() => {
    form.resetFields();
  }, [form]);

  useEffect(() => {
    form.setFieldsValue({
      name: selectedRoles.name,
      is_active: selectedRoles.is_active === 1 ? "1" : "0",
      role_ids: selectedRoles?.roles?.data.map((role) => role.id?.toString()),
    });
  }, [selectedRoles, form]);

  //hide error message after 5 sec
  useEffect(() => {
    if (isErrorVisible) {
      setTimeout(() => {
        setIsErrorVisible(false);
      }, 5000);
    }
  }, [isErrorVisible]);

  const onFinish = async (values: IUserStatus) => {
    try {
      form.setFieldsValue({
        name: selectedRoles.name,
        is_active: selectedRoles.is_active === 1 ? "1" : "0",
      });
      await updateAdmin(values, Number(selectedRoles.id));

      setIsModalVisible(false);
      setIsErrorVisible(false);
      notification["success"]({
        message: "Updated Admin User successfully",
      });
    } catch (error: any) {
      setIsErrorVisible(true);
      if (error?.response?.data?.message) {
        notification["error"]({
          message: error.response.data.message,
        });
      }
    }
  };

  const onValuesChange = (changedValues: any, allValues: any) => {
    Forms.formValueChange(form, changedValues, allValues);
  };

  return (
    <Form
      onFinish={onFinish}
      form={form}
      layout="vertical"
      name="Update Admin User"
      onFieldsChange={onValuesChange}
      ref={formRef}
      initialValues={{
        name: selectedRoles.name,
        role_ids: selectedRoles?.roles?.data.map((role) => role.id?.toString()),
      }}
    >
      <Form.Item
        hidden
        rules={[
          {
            required: true,
            message: "User name is required",
          },
        ]}
        label="Name"
        name="name"
      >
        <Input placeholder="User name" />
      </Form.Item>

      <Form.Item
        rules={[{ required: true, message: "Role is required" }]}
        name="role_ids"
        label="Role"
      >
        <Select
          mode="multiple"
          loading={isLoading}
          placeholder="Please select the Roles"
        >
          {RoleData?.getRoleIdsAsObjectName() &&
            renderOptionsFromEnum(RoleData?.getRoleIdsAsObject())}
        </Select>
      </Form.Item>

      <Form.Item>
        <Button
          loading={isLoading}
          type="primary"
          htmlType="submit"
          style={{ width: "100%" }}
        >
          Submit
        </Button>
      </Form.Item>

      {isErrorVisible && (
        <Alert
          style={{ marginTop: "7px" }}
          message={isError}
          closable
          afterClose={() => setIsErrorVisible(false)}
          type="error"
          showIcon
        />
      )}
    </Form>
  );
};

export default UpdateAdminUserRoleOnly;
